import { FC, ReactNode } from "react";

import { cn } from "@/lib/cn";

interface DetailPageHeaderNavProps {
  titleForm: ReactNode;
  tabs?: ReactNode;
  tabActions?: ReactNode;
  banner?: ReactNode;
}

export const DetailPageHeaderNav: FC<DetailPageHeaderNavProps> = ({ titleForm, tabs, tabActions, banner }) => {
  return (
    <div
      className={cn(
        "relative flex w-full flex-col px-6 text-sm",
        banner ? "pt-6" : "pt-4",
        tabs ? "pb-2" : "pb-4",
      )}
    >
      {banner}
      {titleForm}
      {tabs && (
        <div className="flex w-full flex-row items-center justify-between gap-2 border-b border-solid py-2 text-sm">
          <div className="no-scrollbar flex flex-1 flex-row items-center gap-2 overflow-x-scroll">
            {tabs}
          </div>
          {tabActions && <div className="flex shrink-0 flex-row items-center gap-2">{tabActions}</div>}
        </div>
      )}
    </div>
  );
};
